import React from 'react';

export interface SkipLinkProps {
  targetId?: string;
  children?: React.ReactNode;
}

export const SkipLink: React.FC<SkipLinkProps> = ({
  targetId = 'main-content',
  children = 'Pular para o conteúdo principal',
}) => {
  return (
    <a href={`#${targetId}`} className="nev-skip-link">
      {children}
    </a>
  );
};
